export default "__VITE_ASSET__BBPw5DSq__"